<script setup lang="ts">
</script>

<template>
  <ApplicationFooterSection>
    <DonateModal>
      <ApplicationFooterSectionButton>
        Doneren
      </ApplicationFooterSectionButton>
    </DonateModal>
    <p class="mb-2 text-pretty leading-6 lg:mb-4">
      Wij stellen een donatie zeer op prijs. Elke gedoneerde cent wordt besteed aan eerlijk onderzoekswerk naar de dierindustrie.
    </p>
  </ApplicationFooterSection>
</template>
